import Product from '@src/quince-site-common/src/domains/Product'
import Bundle from '@src/quince-site-common/src/domains/Product/BundleProduct'

import { ProductDetailsIcons } from './constants'

export const addClassBasedOnScroll = (el: HTMLElement, className: string, scrollThreshold: number) => {
  if (!el) return
  const maxScroll = el.scrollWidth - el.clientWidth
  if (maxScroll <= 0) return
  const progress = el.scrollLeft / maxScroll
  if (progress >= scrollThreshold) {
    el.classList.add(className)
  } else {
    el.classList.remove(className)
  }
}

export const getProductDetailsIcons = (product: Product | Bundle): ProductDetailsIcons[] => {
  const icons = product.productDetailIcons?.map(ss => {
    return {
      displayTitle: ss.title || '',
      image: ss,
    }
  })
  return icons && icons.length > 0 ? icons : []
}
